export enum AssetTypeEnum {
  CAR = 'car',
  CUSTOM = 'custom',
}

export enum Action {
  MANAGE = 'manage', // all actions
  READ = 'read',
  WRITE = 'write',
}

export enum PluralEnum {
  SINGULAR = 1,
  PLURAL = 2,
}

export enum ReadStatus {
  PERMANENT = 'PERMANENT',
  STORED = 'STORED',
  PENDING = 'PENDING',
}

export enum Subject {
  all = 'all', // all subjects
  table_dtc = 'dtc',
  stock_number = 'stockNumber',
  work_order = 'workOrder',
  vehicle_battery = 'vehicleBattery',
  seller_id = 'sellerId',
  geofence = 'geofence',
  disclaimer = 'disclaimer',
  mark_as_found = 'markAsFound',
}
